import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/dyb-busmanager-pwa-app/dyb-busmanager-pwa-app/layouts/default.vue").then(m => m.default || m))
}